// extracted by mini-css-extract-plugin
module.exports = {"main":"Switch-module--main--32hpr","imagePanel":"Switch-module--image-panel--2DScT","leftPanel":"Switch-module--leftPanel--3-v3C","switchLink":"Switch-module--switch-link--6Dghp"};